import { lucideIconMappings } from './providers/lucide';
import { CURRENT_ICON_PROVIDER } from './iconConfig';
import { IconMappings } from './types';

// Icon provider mappings
const iconProviders = {
  lucide: lucideIconMappings,
  // Future providers can be added here:
  // heroicons: heroiconsIconMappings,
  // react-icons: reactIconMappings,
} as const;

// Export the current icon mappings based on configuration
export const iconMappings: IconMappings = iconProviders[CURRENT_ICON_PROVIDER];
